/** 0 = Video, 1 = Image */
export enum HeroMediaType {
  Video = 0,
  Image = 1,
}

export interface HeroMediaModel {
  id: number;
  title: string;
  description?: string;
  fileName: string;
  mediaUrl: string;
  thumbnailUrl?: string;
  fileSize: number;
  mediaType: HeroMediaType;
  isActive: boolean;
  order: number;
  campaignStartDate?: string;
  campaignEndDate?: string;
  /** Display duration in seconds for image slides. Null = default 10 seconds. */
  displayDurationSeconds?: number | null;
  createdDate: string;
  updatedDate: string;
}

// Admin-specific models for hero media management
export interface HeroMediaAdminModel {
  id: number;
  title: string;
  description?: string;
  mediaUrl: string;
  thumbnailUrl?: string;
  fileSize: number;
  mediaType: HeroMediaType;
  isActive: boolean;
  order: number;
  campaignStartDate?: string;
  campaignEndDate?: string;
  /** Display duration in seconds for image slides. Null = default 10 seconds. */
  displayDurationSeconds?: number | null;
  createdDate: string;
  updatedDate: string;
}

export interface CreateHeroMediaModel {
  title: string;
  description?: string;
  isActive: boolean;
  mediaType: HeroMediaType;
  campaignStartDate?: string;
  campaignEndDate?: string;
}

export interface EditHeroMediaModel {
  id: number;
  title: string;
  description?: string;
  isActive: boolean;
  order: number;
  campaignStartDate?: string;
  campaignEndDate?: string;
  displayDurationSeconds?: number | null;
}
